"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
/* examples:
 *
 *   <Icon>Account</Icon> // defaults to white
 *
 *   <Icon color="vermillion" >Account</Icon>
 *
 *   <Icon color={(disabled) ? 'vermillion' : 'snow'} >Account</Icon>
 *
 *   <Icon>{(active) ? 'MenuOpenIcon' : 'MenuClosedIcon'} >Menu</Icon>
 *
 *
 *   const StyledIcon = styled(Icon)<{
 *     size: number,
 *   }>`
 *     width: ${props => props.number}px;
 *     height: ${props => props.number}px;
 *   `
 *   <StyledIcon size={50}>Account</StyledIcon>
 *
 *   <Icon withMobile>Search</Icon>
 *          ^ outputs 16px on mobile, 24px everywhere else
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var Icon = function Icon(_ref) {
    var className = _ref.className, _ref$color = _ref.color, color = _ref$color === void 0 ? _theme_1.palette.snow : _ref$color, _ref$children = _ref.children, children = _ref$children === void 0 ? 'account' : _ref$children, _ref$withMobile = _ref.withMobile, withMobile = _ref$withMobile === void 0 ? false : _ref$withMobile;
    var icon = require("../../assets/images/icons/" + children.toLowerCase() + ".svg");
    var mobileIcon = withMobile ? require("../../assets/images/icons/" + children.toLowerCase() + ".mobile.svg") : undefined;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        icon: icon,
        mobileIcon: mobileIcon,
        className: className
    }, {
        color: color
    }));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Icon__Wrapper",
    componentId: "sc-1pwac1p-0"
})(["width:24px;height:24px;background-color:", ";mask-image:url('", "');mask-repeat:no-repeat;mask-position:center;text-indent:-1000px;overflow:hidden;transition:background 0.35s ease-in-out;", ""], function (props) {
    return props.color;
}, function (props) {
    return props.icon;
}, function (props) {
    return props.mobileIcon && "\n    " + _utils_1.mediaQuery('tablet', 'max') + " {\n      width: 16px;\n      height: 16px;\n      mask-image: url('" + props.mobileIcon + "');\n    }\n  ";
}); // Typing
exports.default = Icon;
